import { makeReducer } from '../../core/make-reducer';
import { makeActionCreators } from '../../core/make-action-creators';
import * as API from '../../core/api';
import Project from '../class';

export const actions = {
  REQUEST: 'Dora/project/REQUEST',
  RECEIVE: 'Dora/project/SUCCESS',
  FAIL: 'Dora/project/FAIL',
};

export default makeReducer({ actions });

const actionCreators = makeActionCreators({
  reducerName: 'projectDetails',
  actions,
  requestDataCall: (store, params) =>
    API.get(`projects/${params.projectId}`).then(
      (res) => (res ? new Project(res) : res)
    ),
});

export const requestDataIfNeeded = actionCreators.requestDataIfNeeded;



// WEBPACK FOOTER //
// ./src/projects/details/duck.js